import { Outlet } from "react-router-dom"
const MainProjectCosting = () =>{
    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}

export default MainProjectCosting;